import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../lib/axios.js";

export const useGetLeagueFixtures = (leagueId, page = 1, limit = 10, dateQuery, options = {}) => {
  return useQuery({
    queryKey: ["league-fixtures", leagueId, page, limit, dateQuery],
    queryFn: async () => {
      try {
        console.log(`Fetching league fixtures for date: ${dateQuery}...`);

        const queryParams = { page, limit };
        if (dateQuery) {
          queryParams.date = dateQuery;
        }

        const response = await axiosInstance.get(
          `/leagues/${leagueId}/fixtures`,
          {
            params: queryParams,
            withCredentials: true
          }
        );
        console.log('Server response status:', response.status);
        console.log('Server response data:', response.data);
        return response.data;
      } catch (error) {
        console.error('Error in API call:', error);
        if (error.response) {
          console.error('Response error data:', error.response.data);
          console.error('Response error status:', error.response.status);
          console.error('Response error headers:', error.response.headers);
        } else if (error.request) {
          console.error('No response received:', error.request);
        } else {
          console.error('Error setting up request:', error.message);
        }
        throw error;
      }
    },
    enabled: !!leagueId,
    ...options,
  });
};
